import * as types from './node.types';
import * as constants from './node.constants';
import {
  INodeCreate,
  INodePositionUpdate,
  INodeUpdate,
  IOrganizationChartNode,
} from '../../../resource/node/node.types';

export const createNode = (node: INodeCreate, chartType: string): types.ICreateNode => ({
  type: constants.CREATE_NODE,
  payload: { node, chartType },
});

export const updateNode = (nodeId: IOrganizationChartNode['id'], node: INodeUpdate): types.IUpdateNode => ({
  type: constants.UPDATE_NODE,
  payload: {
    id: nodeId,
    data: node,
  },
});

export const updateNodesPositions = (chartType: string, nodes: INodePositionUpdate[]): types.IUpdateNodesPositions => ({
  type: constants.UPDATE_NODES_POSITIONS,
  payload: { chartType, nodes },
});

export const deleteNode = (nodeId: IOrganizationChartNode['id']): types.IDeleteNode => ({
  type: constants.DELETE_NODE,
  payload: nodeId,
});
